import _ from "lodash";
import Cookies from "js-cookie";

const myStorage = sessionStorage;

function TokenStore() {
  try {
    myStorage.setItem("ls-test", "ls-test");
    myStorage.removeItem("ls-test");
  // myStorage verfügbar
    this._get = function(n) {
      return myStorage.getItem(n);
    };
    this._del = function(n) {
      myStorage.removeItem(n);
    };
    this._set = function(n, v) {
      myStorage.setItem(n, v);
    };
  } catch(e) {
  /*
   * myStorage nicht verfügbar (deaktiviert in Browser-Einstellungen)
   * falle zurück auf Cookies
   * @todo: Durch clevere Optionen Übermittlung von Cookies an Content Service unterbinden?
   */
    const _cookieOpts = {};
    this._get = function(n) {
      return Cookies.get(n);
    };
    this._del = function(n) {
      Cookies.remove(n, _cookieOpts);
    };
    this._set = function(n, v) {
      Cookies.set(n, v, _cookieOpts);
    };
  }

  this.get = function() {
    return this._get("pbpauth");
  };
  this.set = function(value, ticket) {
    if (ticket == this.currentTicket) {
      this._set("pbpauth", JSON.stringify(value));
    }
  };
  this.del = function(ticket) {
    if (ticket == this.currentTicket) {
      this._del("pbpauth");
    }
  };

  this.getTicket = function() {
    return ++this.currentTicket;
  };
  this.currentTicket = 0;
}

export const tokenStore = new TokenStore();

export function getApiHeaders() {
  const stored = tokenStore.get();
  const token = (stored && JSON.parse(stored) || {}).token;
  return { "X-Token": token };
}

export default async function apifetch(url, opts = {}) {
  const headers = opts.headers || (opts.headers = {});

  _.assign(headers, getApiHeaders());
  headers["content-type"] = "application/json";

  if (opts.body && !_.isString(opts.body)) {
    opts.body = JSON.stringify(opts.body);
  }

  const response = await fetch(url, opts);
  if (opts.responseHeaders) {
    for (const [k, v] of response.headers.entries()) {
      opts.responseHeaders[k.toLowerCase()] = v;
    }
  }

  let result;
  if (response.status != 204) {
    result = response && await response.json();
  }
  if (response.status >= 400) {
    const err = Error();
    err.status = response.status;
    err.response = result;
    throw err;
  } else {
    return result;
  }
}

